import React from 'react';
import styled from 'styled-components';
import { nf } from '~/utils';

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  user-select: none;
`;

const Label = styled.div`
  line-height: 1;
  margin-top: 1px;
  padding: ${(p) => (p.bgColor ? 3 : 0)}px;
  background-color: ${(p) => p.bgColor || 'none'};
  color: ${(p) => (p.bgColor ? 'white' : 'black')};
  text-shadow: ${(p) =>
    p.bgColor
      ? '-1px -1px 0 rgba(0,0,0,0.3), 1px -1px 0 rgba(0,0,0,0.3), -1px 1px 0 rgba(0,0,0,0.3), 1px 1px 0 rgba(0,0,0,0.3)'
      : 'none'};
  border-radius: 4px;
`;

const Input = styled.input`
  display: block;
  margin-right: 5px;
  margin-top: 2px;
`;

const Value = styled.div`
  margin-left: auto;
  font-weight: bold;
  color: ${(p) => p.color || 'black'};
  margin-right: 15px;
`;

function Checkbox({ label, value = 0, checked, onChange, bgColor = undefined, style, showValue = true }) {
  return (
    <CheckboxWrapper style={style}>
      <Input type="checkbox" checked={checked} onChange={onChange} />
      <Label bgColor={bgColor}>
        <div>{label}</div>
      </Label>
      {showValue && <Value color={bgColor}>{nf(value)}</Value>}
    </CheckboxWrapper>
  );
}

export default Checkbox;
